import { Component, OnDestroy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { CardModule } from 'primeng/card';
import { InputTextModule } from 'primeng/inputtext';
import { AuxiliarService } from '../../services/auxiliar.service';

@Component({
  selector: 'app-search-field',
  imports: [
    CardModule,
    FormsModule,
    InputTextModule,
    TranslateModule,
  ],
  templateUrl: './search-field.component.html',
  styleUrl: './search-field.component.scss',
})
export class SearchFieldComponent implements OnDestroy {
  public value: string = '';

  constructor(
    private auxiliarService: AuxiliarService,
  ){}

  ngOnDestroy(): void {
    this.auxiliarService.setSearchFilter('');
  }

  public filter(): void {
    this.auxiliarService.setSearchFilter(this.value);
  }
}
